module.exports = __webpack_public_path__ + "img/7.7439e731.jpg";